const BAND_ERROR_CODES = {
  GET_BANDS: "B1",
  GET_BAND: "B2",
  POST_BAND: "B3",
  PATCH_BAND: "B4",
  DELETE_BAND: "B5",
  POST_BAND_SETTING: "B6",
  PATCH_BAND_SETTING: "B7",
  DELETE_BAND_SETTING: "B8",
  GET_BAND_INVITATIONS: "B9",
  GET_BAND_INVITATION: "B10",
  POST_BAND_INVITATION: "B11",
  PATCH_BAND_INVITATION: "B12",
  DELETE_BAND_INVITATION: "B13",
  POST_SEND_BAND_INVITATION: "B14",
  POST_ACCEPT_BAND_INVITATION: "B15",
  POST_REVOKE_BAND_INVITATION: "B16",
  GET_BAND_USERS: "B17",
  PATCH_BAND_USER: "B18",
  DELETE_BAND_USER: "B19",
  POST_COMPANY: "B20",
  PATCH_COMPANY: "B21",
  GET_COMPANIES: "B22",
  GET_INVOICES: "B23",
  GET_CUSTOM_SUBSCRIPTION_REQUESTS: "B24",
  POST_CUSTOM_SUBSCRIPTION_REQUEST: "B25",
  DELETE_CUSTOM_SUBSCRIPTION_REQUEST: "B25b",
  POST_CUSTOM_SUBSCRIPTION: "B26",
  GET_EVENT_PEOPLE_BLOCKS: "B27",
  GET_EVENT_PEOPLE_BLOCK: "B28",
  POST_EVENT_PEOPLE_BLOCK: "B29",
  DELETE_EVENT_PEOPLE_BLOCK: "B31",
  PATCH_EVENT_PEOPLE_BLOCK: "B32",
  PATCH_EVENT_PEOPLE_BLOCK_MEMBER: "B33",
  PATCH_EVENT_PEOPLE_BLOCK_USER: "B34",
  DELETE_EVENT_PEOPLE_BLOCK_USER: "B35",
  GET_EVENT_RSVP: "B36",
  POST_ANSWER_EVENT_RSVP: "B37",
  GET_EVENT_SCHEDULE_BLOCKS: "B39",
  GET_EVENT_SCHEDULE_BLOCK: "B40",
  POST_EVENT_SCHEDULE_BLOCK: "B41",
  PATCH_EVENT_SCHEDULE_BLOCK: "B42",
  DELETE_EVENT_SCHEDULE_BLOCK: "B43",
  POST_EVENT_SCHEDULE_BLOCK_ENTRY: "B44",
  PATCH_EVENT_SCHEDULE_BLOCK_ENTRY: "B45",
  DELETE_EVENT_SCHEDULE_BLOCK_ENTRY: "B46",
  GET_EVENTS: "B47",
  GET_EVENT: "B48",
  POST_EVENT: "B49",
  PATCH_EVENT: "B50",
  DELETE_EVENT: "B51",
  POST_SUBSCRIPTION: "B52",
  PATCH_SUBSCRIPTION: "B53",
  GET_SUBSCRIPTIONS: "B54",
  PATCH_EDIT_TRIAL: "B55",
  POST_CANCEL_SUBSCRIPTION: "B56",
  POST_EDIT_SUBSCRIPTION_COMPANY: "B57",
  POST_CHANGE_PAYMENT_METHOD: "B58",
  PATCH_EVENT_PEOPLE_BLOCK_TITLE: "B59",
  PATCH_EVENT_SCHEDULE_BLOCK_TITLE: "B60",
  GET_EVENT_INFO_BLOCKS: "B61",
  GET_EVENT_INFO_BLOCK: "B62",
  POST_EVENT_INFO_BLOCK: "B63",
  PATCH_EVENT_INFO_BLOCK: "B64",
  DELETE_EVENT_INFO_BLOCK: "B65",
  GET_PERMISSION_TYPES: "B66",
  GET_BAND_USER_PERMISSIONS: "B67",
  GET_USER_PERMISSIONS: "B68",
  PATCH_USER_PERMISSIONS: "B69",
  GET_EVENT_VENUE_BLOCKS: "B70",
  GET_EVENT_VENUE_BLOCK: "B71",
  POST_EVENT_VENUE_BLOCK: "B72",
  DELETE_EVENT_VENUE_BLOCK: "B73",
  PATCH_EVENT_VENUE_BLOCK: "B74",
  GET_BAND_ICALS: "B75",
  POST_BAND_ICALS: "B76",
  PATCH_BAND_ICALS: "B77",
  DELETE_BAND_ICALS: "B78",
  GET_EVENT_GUESTLIST_BLOCKS: "B79",
  GET_EVENT_GUESTLIST_BLOCK: "B80",
  POST_EVENT_GUESTLIST_BLOCK: "B81",
  PATCH_EVENT_GUESTLIST_BLOCK: "B82",
  DELETE_EVENT_GUESTLIST_BLOCK: "B83",
  GET_EVENT_TICKET_PASSES: "B84",
  POST_EVENT_TICKET_PASSES: "B85",
  POST_EVENT_TICKET_PASS: "B86",
  PATCH_EVENT_TICKET_PASS: "B87",
  DELETE_EVENT_TICKET_PASS: "B88",
  POST_EVENT_GUEST: "B89",
  PATCH_EVENT_GUEST: "B90",
  DELETE_EVENT_GUEST: "B91",
  GET_EVENT_GUESTS: "B92",
  DOWNLOAD_EVENT_GUESTLIST_BLOCK: "B93",
  GET_EVENT_TRAVEL_BLOCKS: "B94",
  GET_EVENT_TRAVEL_BLOCK: "B95",
  POST_EVENT_TRAVEL_BLOCK: "B96",
  DELETE_EVENT_TRAVEL_BLOCK: "B97",
  PATCH_EVENT_TRAVEL_BLOCK: "B98",
  PATCH_EVENT_TRAVEL_BLOCK_TITLE: "B99",
  POST_EVENT_TRAVEL_LEG: "B100",
  DELETE_EVENT_TRAVEL_LEG: "B101",
  PATCH_EVENT_TRAVEL_LEG: "B102",
  GET_EVENT_TRAVEL_BLOCK_PASSENGERS: "B103",
  GET_EVENT_TRAVEL_BLOCK_PASSENGER: "B104",
  POST_EVENT_TRAVEL_BLOCK_PASSENGER: "B105",
  DELETE_EVENT_TRAVEL_BLOCK_PASSENGER: "B106",
  PATCH_EVENT_TRAVEL_BLOCK_PASSENGER: "B107",
  GET_EVENT_SUGGESTED_LOCATIONS: "B108",
  GET_EVENT_SUGGESTED_LOCATION: "B108a",
  CREATE_EVENT_ACCOMMODATION_BLOCK: "B109",
  CREATE_EVENT_ACCOMMODATION_ROOM: "B110",
  GET_EVENT_ACCOMMODATION_BLOCKS: "B111",
  DELETE_EVENT_ACCOMMODATION_BLOCK: "B112",
  PATCH_EVENT_ACCOMMODATION_BLOCK_TITLE: "B113",
  PATCH_EVENT_ACCOMMODATION_BLOCK: "B114",
  CREATE_EVENT_ACCOMMODATION_RESERVATION: "B115",
  GET_EVENT_ACCOMMODATION_BLOCK: "B116",
  GET_EVENT_ACCOMMODATION_ROOM_TYPES: "B117",
  DELETE_EVENT_ACCOMMODATION_ROOM_TYPE: "B118",
  PATCH_EVENT_ACCOMMODATION_ROOM_TYPE: "B119",
  DELETE_EVENT_ACCOMMODATION_RESERVATION: "B120",
  GET_EVENT_ACCOMMODATION_RESERVATIONS: "B121",
  PATCH_EVENT_ACCOMMODATION_RESERVATION: "B122",
  GET_EVENT_ACCOMMODATION_ROOMS: "B123",
  CREATE_EVENT_DETAILS_EXPORT: "B124",
  GET_EVENT_DETAILS_EXPORT: "B125",
  POST_GET_PAYMENT_INFO: "B126",
  POST_IMPORT_EVENT_BLOCKS: "B127",
  POST_EVENTS_EXPORT_CONFIGS: "B128",
};

const AUTH_ERROR_CODES = {
  GET_USER: "A1",
  PATCH_USER: "A2",
  DELETE_USER: "A3",
  POST_CHANGE_EMAIL: "A4",
  POST_CONFIRM_EMAIL: "A5",
  GET_USER_ADDRESS: "A6",
  POST_USER_ADDRESS: "A7",
  PATCH_USER_ADDRESS: "A8",
  DELETE_USER_ADDRESS: "A9",
  POST_USER_PHONE_NUMBER: "A10",
  PATCH_USER_PHONE_NUMBER: "A11",
  DELETE_USER_PHONE_NUMBER: "A12",
  GET_USER_PHONE_NUMBER: "A13",
  GET_USER_EMERGENCY_CONTACTS: "A14",
  POST_USER_EMERGENCY_CONTACT: "A15",
  PATCH_USER_EMERGENCY_CONTACT: "A16",
  DELETE_USER_EMERGENCY_CONTACT: "A17",
  GET_USER_HOME_BASES: "A18",
  POST_USER_HOME_BASE: "A19",
  PATCH_USER_HOME_BASE: "A20",
  DELETE_USER_HOME_BASE: "A21",
  GET_USER_PASSPORTS: "A22",
  POST_USER_PASSPORT: "A23",
  PATCH_USER_PASSPORT: "A24",
  DELETE_USER_PASSPORT: "A25",
  GET_USER_TRAVEL_VISAS: "A26",
  POST_USER_TRAVEL_VISA: "A27",
  PATCH_USER_TRAVEL_VISA: "A28",
  DELETE_USER_TRAVEL_VISA: "A29",
  GET_USER_SOCIAL_SECURITY_FORMS: "A26",
  POST_USER_SOCIAL_SECURITY_FORM: "A27",
  PATCH_USER_SOCIAL_SECURITY_FORM: "A28",
  DELETE_USER_SOCIAL_SECURITY_FORM: "A29",
  GET_USER_DRIVING_PERMITS: "A30",
  POST_USER_DRIVING_PERMIT: "A31",
  PATCH_USER_DRIVING_PERMIT: "A32",
  DELETE_USER_DRIVING_PERMIT: "A33",
  GET_USER_VEHICLES: "A34",
  POST_USER_VEHICLE: "A35",
  PATCH_USER_VEHICLE: "A36",
  DELETE_USER_VEHICLE: "A37",
  GET_USER_LOYALTY_PROGRAMS: "A38",
  POST_USER_LOYALTY_PROGRAM: "A39",
  PATCH_USER_LOYALTY_PROGRAM: "A40",
  DELETE_USER_LOYALTY_PROGRAM: "A41",
  POST_USER_API_KEY: "A42",
  GET_USER_API_KEY: "A43",
  DELETE_USER_API_KEY: "A44",
};

export const API_ERROR_CODES = { ...BAND_ERROR_CODES, ...AUTH_ERROR_CODES };
